<template>
  <v-card>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 class="headline">Commit Batch and its allocation lines?</v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="close()" :color="primaryGrey">Close</v-btn>
      <v-btn
        flat
        @click="commitBatch()"
        outline
        :color="$store.state.global.pages.allocation.color"
        :loading="loading"
      >Commit</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import AllocationService from "@/services/requests/allocationService";
export default {
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    commitBatch() {
      if (
        this.batch.tipConfirmed != "CONFIRMED" ||
        this.batch.siteConfirmed != "CONFIRMED" ||
        this.batch.amendmentsConfirmed != "CONFIRMED"
      ) {
        this.snack({
          text:
            "Please confirm Tip, Site and Amendments before committing Batch",
          color: "yellow",
        });
        this.close();
        return;
      }
      this.loading = true;
      AllocationService.commitBatch(this.batch)
        .then((result) => {
          this.loading = false;
          this.snack({
            text: `Batch was commited! ${
              result.data.result.allocationsCreated
            } of ${
              result.data.result.possibleAllocationsCreated
            } allocations were created`,
            color: "green",
          });
          this.close();
          this.fetchBatches = true;
        })
        .catch((err) => {
          this.loading = false;
          this.snack({ text: err.response.data.message, color: "red" });
        });
    },
    close() {
      this.$emit("close");
    },
  },
  computed: {
    fetchBatches: Store.getSet({
      store: "allocationStaging",
      prop: "fetchBatches",
    }),
  },
  props: {
    batch: Object,
  },
};
</script>
